import React from 'react';
import { WagWebUrl } from '../../../../constants/app';
import { WellnessAuthorBlock, WellnessAuthorBlockProps } from '../../../../wag-react/components/author-block/WellnessAuthorBlock';
import { Grid, GridProps } from '../../../../wag-react/core-components/grid';
import { Box } from '../../../../wag-react/next-components/box';
import { Button } from '../../../../wag-react/next-components/button';
const bookALocalPetCareUrl = WagWebUrl.Home;
export type WellnessArticleAuthorBlockProps = Omit<GridProps, 'value'> & Pick<WellnessAuthorBlockProps, 'value'>;
export const WellnessArticleAuthorBlock = ({
  value,
  ...rest
}: WellnessArticleAuthorBlockProps) => <Grid gridGap="30px" gridTemplateColumns={['1fr', null, '1fr max-content']} py={['unset', null, '24px']} {...rest} data-sentry-element="Grid" data-sentry-component="WellnessArticleAuthorBlock" data-sentry-source-file="index.tsx">
    <Box backgroundColor={['#F5F5F5', 'unset']} p="8px" data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <WellnessAuthorBlock value={{
      ...value,
      // Cancel out breed since not part of the design
      breed: ''
    }} data-sentry-element="WellnessAuthorBlock" data-sentry-source-file="index.tsx" />
    </Box>
    <Box justifySelf={['center', null, 'end']} py={['unset', null, '24px']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <Button href={bookALocalPetCareUrl} target="_blank" variant="contained" data-sentry-element="Button" data-sentry-source-file="index.tsx">
        Book local pet care
      </Button>
    </Box>
  </Grid>;